import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'
import React from 'react'

const Text = ({ align, children, color, component, variant, sx }) => (
  <Typography align={align} color={color} component={component} variant={variant} sx={sx}>
    {children}
  </Typography>
)

Text.propTypes = {
  align: PropTypes.oneOf(['center', 'inherit', 'justify', 'left', 'right']),
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  component: PropTypes.string,
  variant: PropTypes.string.isRequired,
  sx: PropTypes.shape({}),
}

Text.defaultProps = {
  align: 'inherit',
  component: 'div',
  color: null,
  sx: null,
}

export default Text
